import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export function catalogFormEditBasicFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    { key: 'name', type: 'input', className: 'mb-2 block', props: { label: translate.instant('CATALOG.INTERNAL_NAME'), required: true } },
    { key: 'title', type: 'input', className: 'mb-2 block', props: { label: translate.instant('CATALOG.TITLE'), required: true } },
  ];
}

export function catalogFormEditImportFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    { key: 'importUrl', type: 'input', className: 'mb-2 block', props: { label: translate.instant('CATALOG.IMPORT_URL') } },
    { key: 'privateImportKey', type: 'input', className: 'mb-2 block', props: { label: translate.instant('CATALOG.PRIVATE_IMPORT_KEY'), type: 'password' } },
  ];
}

export function catalogFormEditExportFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    { key: 'exportUrl', type: 'input', className: 'mb-2 block', props: { label: translate.instant('CATALOG.EXPORT_URL') } },
    { key: 'privateExportKey', type: 'input', className: 'mb-2 block', props: { label: translate.instant('CATALOG.PRIVATE_EXPORT_KEY'), type: 'password' } },
  ];
}

export function catalogFormEditExtraFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    {
      key: 'extraFields',
      type: 'repeat',
      props: { addText: 'Añadir campo extra' },
      fieldArray: {
        fieldGroup: [
          { key: 'key', type: 'input', className: 'flex-1', props: { label: 'Clave', required: true } },
          { key: 'value', type: 'input', className: 'flex-1', props: { label: 'Valor', required: true } },
        ],
      },
    },
  ];
}

// Keep backward compat
export function catalogFormEditFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    ...catalogFormEditBasicFields(translate),
    ...catalogFormEditImportFields(translate),
    ...catalogFormEditExportFields(translate),
    ...catalogFormEditExtraFields(translate),
  ];
}
